// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3y_BJ","choiceBoxes":"toolbarselects_choiceBoxes__3OO58","simpleField":"toolbarselects_simpleField__Bl_DS"};